module.exports = __webpack_public_path__ + "img/logo-type.0653de63.svg";